import { getDateTime } from '../../../helpers/utils'
import translate from '../../../i18n'
import {
  IPublicPrelaunchStudioDto,
  PrelaunchConfirmationStatusEnum,
} from '../../../pages/prelaunch-organization-forms-container/share-types'
import { Button, Descriptions, Popconfirm, Space, Tag } from 'antd'

interface IProps {
  data: IPublicPrelaunchStudioDto[]
  isExpired: boolean
  uniqueId: string
  organizationName: string
  onDelete: (id: number) => void
}

const PrelaunchStudios = (props: IProps) => {
  const { data, uniqueId, isExpired, organizationName, onDelete } = props

  const getStudioStatusTagColor = (status: string) => {
    switch (status) {
      case PrelaunchConfirmationStatusEnum.SUBMITTED:
        return 'green'
      case PrelaunchConfirmationStatusEnum.CONFIRMED:
        return 'blue'
      default:
        return 'blue'
    }
  }

  return (
    <>
      <Space orientation="vertical" style={{ width: '100%' }} size={16}>
        {data.map(item => (
          <Descriptions column={{ xs: 1, sm: 2 }}>
            <Descriptions.Item label={translate('studioTranslation.name')}>
              <Space>
                {item.name}
                {!isExpired && (
                  <a
                    href={`/public/prelaunch-organization-form/${uniqueId}/studios/${item.id}/${organizationName}/duplicate`}
                  >
                    {translate('duplicate')}
                  </a>
                )}
                {!isExpired && item.status === PrelaunchConfirmationStatusEnum.SUBMITTED && (
                  <>
                    <a
                      href={`/public/prelaunch-organization-form/${uniqueId}/studios/${item.id}/${organizationName}/edit`}
                    >
                      {translate('edit')}
                    </a>
                    <Popconfirm
                      title="删除场馆"
                      description="删除后不可恢复，确认删除吗？"
                      onConfirm={() => onDelete(item.id)}
                    >
                      <Button type="link" danger>
                        {translate('delete')}
                      </Button>
                    </Popconfirm>
                  </>
                )}
              </Space>
            </Descriptions.Item>
            <Descriptions.Item label={translate('studio.status')}>
              <Tag color={getStudioStatusTagColor(item.status)}>{item.status}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label={translate('city')}>{item.city}</Descriptions.Item>
            <Descriptions.Item label={translate('studioTranslation.address1')}>
              {item.address1}
            </Descriptions.Item>
            <Descriptions.Item label={translate('studioTranslation.address2')}>
              {item.address2}
            </Descriptions.Item>
            <Descriptions.Item label={translate('createdAt')}>
              {getDateTime(item.createdAt)}
            </Descriptions.Item>
            <Descriptions.Item label={translate('updatedAt')}>
              {getDateTime(item.updatedAt)}
            </Descriptions.Item>
          </Descriptions>
        ))}
      </Space>
    </>
  )
}

export default PrelaunchStudios
